<template>
  <section class="text-center">
    <div class="container">
      <div class="grid grid_gutters-sm grid_h-center grid_v-margins">
        <div class="grid__col grid__col_auto">
          <button
            v-if="$root.$i18n.locale === 'ru'"
            class="button button_lg button_primary"
            @click.prevent="$emit('sendRequest')"
          >
            <span class="button__text" v-html="$t('common/send-request')"></span>
          </button>
          <a
            v-else
            class="button button_lg button_primary"
            href="mailto:info@mysport.photo"
          >
            <span class="button__text" v-html="$t('common/send-request')"></span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
export default {
  name: 'Actions',
};
</script>

<style lang="scss" scoped>
@import "~@rr-component-library/common/src/scss/mixins.scss";
@import "@/scss/colors.scss";
@import "@/scss/static-pages/main.scss";

section {
  margin-top: 48px;
  @include v-spacing("margin-bottom", xl);

  @media (min-width: breakpoint(md)) {
    margin-top: 64px;
  }
}
</style>
